import { render, staticRenderFns } from "./tramite-beneficiario-documento.vue?vue&type=template&id=37eeae12&"
import script from "./tramite-beneficiario-documento.vue?vue&type=script&lang=ts&"
export * from "./tramite-beneficiario-documento.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports